import PageWithSidebar from '@/src/Common/components/PageWithSidebar';
import { Tabs, TabsContent } from '@/src/shadComponents/ui/tabs';
import DeviceKeys from './DeviceKeys';
import DeviceGroups from './DeviceGroups';
import {
    FolderArrowDownIcon,
    KeyIcon,
    UserGroupIcon,
    CpuChipIcon,
} from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import SoftwareReleases from './SoftwareReleases';
import AutoEnrollment from './AutoEnrollment';
import { useContext } from 'react';
import FeatureFlagContext from '@/src/Features/components/FeatureFlagContext';
import { useWorld } from '@/src/v3/chrome/UnifiedFrame';
import { WEB_V3_FLAG } from '@/src/v3/flags';
import DevicesV3 from '@/src/v3/pages/DevicesV3';

export default function DeviceManagement() {
    /* the v3 world gets the v3 devices page */
    const flags = useContext(FeatureFlagContext) as Record<string, boolean>;
    const unified = useWorld(!!flags?.[WEB_V3_FLAG]);
    return unified ? <DevicesV3 /> : <DeviceManagementClassic />;
}

function DeviceManagementClassic() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const navigate = useNavigate();
    let splitPath = window.location.href.split('#');
    let selectedTab = splitPath.length > 1 ? splitPath[1] : 'keys';

    return (
        <PageWithSidebar
            title="Device Management"
            subtitle="Manage your devices and groups."
            actions={null}
            navigation={[
                {
                    name: 'Device Keys',
                    href: '#keys',
                    current: selectedTab === 'keys',
                    icon: KeyIcon,
                },
                {
                    name: 'Device Groups',
                    href: '#groups',
                    current: selectedTab === 'groups',
                    icon: UserGroupIcon,
                },
                {
                    name: 'Auto Enrollment',
                    href: '#autoenrollment',
                    current: selectedTab === 'autoenrollment',
                    icon: CpuChipIcon,
                },
                {
                    name: 'Software',
                    href: '#software',
                    current: selectedTab === 'software',
                    icon: FolderArrowDownIcon,
                },
            ]}
        >
            <Tabs value={`${selectedTab}`}>
                <TabsContent value="keys">
                    <DeviceKeys />
                </TabsContent>
                <TabsContent value="groups">
                    <DeviceGroups />
                </TabsContent>
                <TabsContent value="autoenrollment">
                    <AutoEnrollment />
                </TabsContent>
                <TabsContent value="software">
                    <SoftwareReleases />
                </TabsContent>
            </Tabs>
        </PageWithSidebar>
    );
}
